define([
	"dojo/_base/declare",
	"./AttributeSelect",
], function(declare, AttributeSelect) {

	return declare(AttributeSelect, {
		/**
		 * Allow attribute to be inline edited even when ViewRef is specified
		 * @override
		 */
		canBeInlined(node) {
			return true;
		}
	});
});